// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___KCMy","right":"styles_right__3mXrW"};